export default __webpack_public_path__ + "static/media/icon_rotation_start.fc7d957b.svg";